<template>


    <div class="min-h-[50px] col-span-2 border-2 border-green border-solid
                pl-[30px] py-2 self-center text-black"
         :class="classes">

        {{ message }}

    </div>


</template>


<script>
import { defineComponent } from "vue";
import 'flatpickr/dist/flatpickr.css';

export default defineComponent({

    components: {

    },

    props: {
        classes: {
            type: String,
            default: '',
        },
        message: {
            type: String,
            default: '',
        }
    },
});
</script>

<style scoped>

</style>
